import type { GrupoCajaChica } from '../../services/tesoreriaService';

export function persistGrupoCajaChica(grupo: GrupoCajaChica): void {
    try {
        localStorage.setItem('grupoCajaChicaSeleccionado', JSON.stringify(grupo));
        localStorage.setItem('grupoCajaMcp', String(grupo.codigo ?? ''));
    } catch {
        /* ignore */
    }
}

export function findGrupoCajaGuardado(grupos: GrupoCajaChica[]): GrupoCajaChica | null {
    const saved = localStorage.getItem('grupoCajaChicaSeleccionado');
    if (!saved) return null;
    try {
        const parsed = JSON.parse(saved);
        const savedId = parsed?.id ?? null;
        if (savedId != null) {
            const byId = grupos.find((g) => g.id === savedId);
            if (byId) return byId;
        }
        const codigo = Number(parsed?.codigo ?? null);
        if (Number.isFinite(codigo) && codigo > 0) {
            return grupos.find((g) => g.codigo === codigo) ?? null;
        }
    } catch {
        /* ignore */
    }
    return null;
}
